import { createSlice } from '@reduxjs/toolkit'

const faqSlice = createSlice({
    name: 'faqs',
    initialState: {
        faqList: []
    },
    reducers: {
        fetchFaqsAction: (state, action) => {
            state.faqList = [action.payload]
        }
    }

})
export const {fetchFaqsAction} = faqSlice.actions


export default faqSlice